import React from "react";
import { translate } from "../../../../../../../../../providers";
import styles from "./PromptStage.module.css";
import { BoxSelector, CustomTooltip, icon, IconComponent } from "../../../../../../../..";
import { isNonEmptyArray } from "../../../../../../../../../utils";

const PromptStage = ({
	instructions,
	isMultiSelect = false,
	onChangeInstructions,
	promptModelHelperText = "",
	promptModels,
	promptModelsTitle = "",
	selection = [],
}) => (
	<div className={styles.container}>
		<div className={styles.title}>
			<span>{promptModelsTitle || translate("common:component.ai-config.prompt-models")}</span>
			{!!promptModelHelperText && (
				<CustomTooltip title={promptModelHelperText}>
					<IconComponent color="var(--grey-500)" icon={icon.faInfoCircle} />
				</CustomTooltip>
			)}
			<span className={styles.asterixContainer}>*</span>
		</div>
		<div className={styles.promptModels}>
			{isNonEmptyArray(promptModels) &&
				promptModels.map((model) => {
					const isSelected = isMultiSelect
						? selection.some((s) => s === model.value)
						: instructions === model.value;
					return (
						<BoxSelector
							key={model.title}
							className={styles.promptBox}
							selected={isSelected}
							subTitle={model.subTitle}
							title={model.title}
							value={model.value}
							onClick={onChangeInstructions}
						/>
					);
				})}
		</div>
	</div>
);

export default PromptStage;
